import * as React from 'react';

function SvgContactEmail(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="contact_email_svg__prefix__contact_email"
      width={94}
      height={70}
      {...props}
    >
      <defs>
        <clipPath id="contact_email_svg__prefix__clip-path" />
        <filter
          id="contact_email_svg__prefix__Rectangle_378"
          width={112}
          height={88}
          x={-9}
          y={-9}
          filterUnits="userSpaceOnUse"
        >
          <feOffset />
          <feGaussianBlur result="blur" stdDeviation={3} />
          <feFlood floodOpacity={0.102} />
          <feComposite in2="blur" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <style>{'.contact_email_svg__prefix__cls-1{fill:#fff}'}</style>
      </defs>
      <g
        id="contact_email_svg__prefix__Mask_Group_1"
        fill="#ff4893"
        clipPath="url(#contact_email_svg__prefix__clip-path)"
        data-name="Mask Group 1"
        opacity={0.9}
      >
        <ellipse
          id="contact_email_svg__prefix__Ellipse_34"
          cx={61.25}
          cy={60.969}
          data-name="Ellipse 34"
          opacity={0.5}
          rx={61.25}
          ry={60.969}
          transform="translate(-28.5 -24.496)"
        />
        <ellipse
          id="contact_email_svg__prefix__Ellipse_35"
          cx={44.866}
          cy={47.786}
          data-name="Ellipse 35"
          rx={44.866}
          ry={47.786}
          transform="translate(-12.116 -11.313)"
        />
      </g>
      <g
        id="contact_email_svg__prefix__Group_2205"
        data-name="Group 2205"
        transform="translate(14.687 -146.236)"
      >
        <g
          id="contact_email_svg__prefix__Group_2204"
          data-name="Group 2204"
          transform="translate(0 163.128)"
        >
          <path
            id="contact_email_svg__prefix__Path_4950"
            d="M39.178 163.128H5.457A5.462 5.462 0 000 168.585v23.047a5.462 5.462 0 005.457 5.457h33.712a5.462 5.462 0 005.457-5.457v-23.038a5.456 5.456 0 00-5.448-5.466zm2.964 28.5a2.967 2.967 0 01-2.964 2.964H5.457a2.967 2.967 0 01-2.964-2.964v-23.034a2.967 2.967 0 012.964-2.964h33.712a2.967 2.967 0 012.964 2.964v23.038z"
            className="contact_email_svg__prefix__cls-1"
            data-name="Path 4950"
            transform="translate(0 -163.128)"
          />
          <path
            id="contact_email_svg__prefix__Path_4951"
            d="M93.595 239.874l10.914-9.788a1.249 1.249 0 10-1.671-1.856l-15.051 13.509-2.936-2.622c-.009-.009-.018-.018-.018-.028a1.849 1.849 0 00-.2-.175l-11.952-10.693a1.249 1.249 0 10-1.662 1.865l11.043 9.871-11 10.3a1.252 1.252 0 00-.055 1.764 1.275 1.275 0 00.914.4 1.249 1.249 0 00.849-.332l11.163-10.443 3.029 2.705a1.243 1.243 0 001.662-.009l3.112-2.789 11.1 10.545a1.25 1.25 0 001.764-.046 1.252 1.252 0 00-.046-1.764z"
            className="contact_email_svg__prefix__cls-1"
            data-name="Path 4951"
            transform="translate(-65.451 -223.179)"
          />
        </g>
      </g>
    </svg>
  );
}

export default SvgContactEmail;
